import React, { useEffect, useState } from "react";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import { Button } from "../../components/Button";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import { vomColumnsDefs } from "../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { VOMNavbar } from ".";
import { isValidEmail, LiButton } from "../../Utils/CustomComponent";
import { fetchVOMRequests } from "../../store/reducers/dashboardSlice/api";

const VOMMainPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const data = useSelector((state) => state.dashboard.vomRequests.data);
  const status = useSelector((state) => state.dashboard.vomRequests.status);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { email } = useParams();
  const location = useLocation();
  // const isABorrower = location?.pathname?.includes("/vom/borrower/");

  const pendingRequests =
    data?.filter((item) => item?.status === "PENDING") ?? [];
  const submittedRequests =
    data?.filter((item) => item?.status === "SUBMITTED") ?? [];
  const closedRequests =
    data?.filter((item) => item?.status === "CLOSED") ?? [];

  useEffect(() => {
    if (email) {
      dispatch(fetchVOMRequests({ email }));
    }
  }, [dispatch, email]);

  if (!email || !isValidEmail(email)) {
    return <Navigate to="unauthorized" replace />;
  }

  const componentConfig = [
    {
      component: (
        <Heading className="col-sm-12" text="Verification of Mortgage" />
      ),
      role: ["Both"],
      className: "col-sm-6 px-5",
    },
    {
      component: (
        <Button
          className=""
          onClick={() => navigate(`/verification-form/${email}`)}
          text="+ Request Verification of Mortgage"
        />
      ),
      role: ["Both"],
      // className: `col-sm-6 px-5 text-end ${isABorrower && "d-none"}`,
      className: `col-sm-6 px-5 text-end`,
    },
    {
      component: (
        <div>
          <ul className="nav nav-tabs mt-5 px-5">
            {tabButtons.map((data, index) => (
              <LiButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
              />
            ))}
          </ul>

          <section className="row d-flex flex-row align-items-stretch justify-content-stretch px-5">
            {activeTab === 0 && (
              <CommonGrid
                className={"bg-white col-sm-12 mt-5"}
                title={"Pending VOM Requests"}
                gridColumns={vomColumnsDefs(navigate, email)}
                columnData={pendingRequests}
                status={status}
              />
            )}
            {activeTab === 1 && (
              <CommonGrid
                className={"bg-white col-sm-12 mt-5"}
                title={"Completed VOM Requests"}
                gridColumns={vomColumnsDefs(navigate, email)}
                columnData={submittedRequests}
                status={status}
              />
            )}
            {activeTab === 2 && (
              <CommonGrid
                className={"bg-white col-sm-12 mt-5"}
                title={"Closed VOM Requests"}
                gridColumns={vomColumnsDefs(navigate, email)}
                columnData={closedRequests}
                status={status}
              />
            )}
          </section>
        </div>
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <VOMNavbar />
      <section
        className=" rounded pb-5"
        style={{
          background: "#eeeeee",
          minHeight: "100vh",
          paddingTop: "80px",
        }}
      >
        {/* {!isABorrower ? ( */}
          <nav aria-label="breadcrumb" className="mb-4 mx-5 px-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <span
                  className="linkClick"
                  role="button"
                  onClick={() => navigate(-1)}
                >
                  Back
                </span>
              </li>
              <li className="breadcrumb-item active">VOM Requests</li>
            </ol>
          </nav>
         {/* ) : ( */}
           {/* <div className="mb-5" /> */}
         {/* )} */}

        <article className="container-fluid row">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default VOMMainPage;

const tabButtons = [
  {
    label: "Pending Requests",
    title: "Pending Requests",
  },
  { label: "Submitted Requests", title: "Submitted Requests" },
  { label: "Closed Requests", title: "Closed Requests" },
];
